import React, { Dispatch, SetStateAction, useState } from "react";
import DeletePopUp from "../DeletePopUp";
import { Pencil } from "lucide-react";
import {
  renderTableExistingFilePreview,
  renderTableFilePreview,
} from "../../exports/functions";
import { IExecutiveMemberInput } from "../../exports/interfaces";

const ExecutiveTable = ({
  executiveData,
  setExecutiveCooperative,
  setEditExecutiveIndex,
  editExecutiveIndex,
  setExecutiveTableCooperative,
}: {
  executiveData: IExecutiveMemberInput[];
  setExecutiveCooperative: Dispatch<SetStateAction<IExecutiveMemberInput>>;
  setEditExecutiveIndex: Dispatch<SetStateAction<number | null>>;
  editExecutiveIndex: number | null;
  setExecutiveTableCooperative: Dispatch<
    SetStateAction<IExecutiveMemberInput[]>
  >;
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const handleClose = () => {
    setShowDelete(false);
    setDeleteIndex(null);
  };

  const handleDelete = () => {
    if (deleteIndex === null) return;

    setExecutiveTableCooperative((prev) =>
      prev.filter((_, i) => i !== deleteIndex),
    );

    if (editExecutiveIndex === deleteIndex) {
      setEditExecutiveIndex(null);
      setExecutiveCooperative({
        position: "",
        positionStatus: "",
        grandmotherName: "",
        fatherName: "",
        maritalStatus: "",
        husbandName: "",
        fullName: "",
        gender: "",

        email: "",
        address: "",
        mobile: "",
        pan: "",
        nid: "",
        citizenship: "",
        issuedDistrict: "",

        province: "",
        district: "",
        municipality: "",
        ward: null,
        street: "",

        experience: null,
        currentPositionDuration: null,
        education: "",
        file: null,
        fileName: "",
        citizenshipFront: null,
        citizenshipFrontName: "",
        citizenshipBack: null,
        citizenshipBackName: "",
      });
    } else if (
      editExecutiveIndex !== null &&
      editExecutiveIndex > deleteIndex
    ) {
      // Update edit index after deleting an item before it
      setEditExecutiveIndex(editExecutiveIndex - 1);
    }

    setDeleteIndex(null);
    setShowDelete(false);
  };
  return (
    <>
      <div className="dashboard-card mt-3">
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Photo</th>
                <th>Full Name</th>
                <th>Contact No.</th>
                <th>Email</th>
                <th className="sticky-action">Actions</th>
              </tr>
            </thead>

            <tbody>
              {executiveData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>

                  <td>
                    {item.file
                      ? renderTableFilePreview(item.file, item.fileName)
                      : item.documentUrl
                        ? renderTableExistingFilePreview(item.documentUrl)
                        : null}
                  </td>

                  <td>{item.fullName}</td>
                  <td>{item.mobile}</td>
                  <td>{item.email}</td>

                  <td className="sticky-action">
                    <div className="d-flex gap-2 align-items-center">
                      <i
                        className="cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Edit"
                      >
                        <Pencil
                          size={20}
                          onClick={() => {
                            setExecutiveCooperative({
                              ...item,
                            });

                            setEditExecutiveIndex(index);
                          }}
                        />
                      </i>
                      <i
                        className="fa-solid fa-trash text-danger cursor-pointer"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete"
                         onClick={() => {
                          setDeleteIndex(index);
                          setShowDelete(true);
                        }}
                      ></i>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showDelete && <DeletePopUp onClose={handleClose} onConfirm={handleDelete} message="This item will be marked for deletion and will be permanently deleted only after you save your changes"/>}
    </>
  );
};

export default ExecutiveTable;
